module.exports = __webpack_public_path__ + "static/media/IMG_1453.057fcfb8.PNG";